import React from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";

const ScreenHeader = props => {
  return (
    <header className="screen-header">
      <div className="left">{props.left}</div>
      <div className="center">{props.title}</div>
      <div className="right">{props.right}</div>
    </header>
  );
};

ScreenHeader.propTypes = {
  title: PropTypes.string.isRequired,
  left: PropTypes.node,
  right: PropTypes.node
};

ScreenHeader.defaultProps = {
  left: null,
  right: null
};

export default withNamespaces(["regions", "common"], { wait: true })(
  ScreenHeader
);
